import {
    REQUEST as req,
    RESPONSE as res,
    FAILURE as fail
} from '../../actions/segments/list';

const initialState = {
    response: {},
    isLoading: true,
    error: null
  };
  export const reducer = (state = initialState, action) => {
    switch (action.type) {
      case req:
        return {
          ...state,
          isLoading: true,
          error: null
        };
      case res:
        return {
          ...state,
          isLoading: false,
          response: action.payload
        };
      case fail:
        return {
          ...state,
          isLoading: false,
          error: action.payload
        };
      default:
        return state;
    }
  };